import {supportedLanguages} from './utils/locales'

export default {
  supportedLocales: [...supportedLanguages],
  fallbackLng: 'en',
  defaultNS: 'common'
}
